import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import LazyLoad from 'react-lazyload';
import _ from 'lodash';
import { getProductsRequest } from '../store/actions/products';
import Loader from './Loader';

function ProductsTable() {
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  const products = useSelector((state) => state.products.products);

  useEffect(() => {
    (async () => {
      setLoading(true);
      await dispatch(getProductsRequest({ page: 1 }));
      setLoading(false);
    })();
  }, []);

  if (!loading && _.isEmpty(products)) {
    return <div className="noData">No data</div>;
  }
  return (
    <div className="table productsTable">
      {!(loading && _.isEmpty(products)) ? (
        <div className="table">
          <div className="head">
            <div className="productName">Product Name</div>
            <div className="item">Item</div>
            <div className="qty">Quantity</div>
            <div className="price">Price</div>
            <div className="category">Category</div>
            <div className="status">Status</div>
          </div>
          <div className="body">
            {products.map((product) => (
              <LazyLoad className="row" offset={100} height={62} unmountIfInvisible key={product.id}>
                <div className="productName">
                  {product.name}
                </div>
                <div className="item">
                  {`#${product.itemNumber}`}
                </div>
                <div className="qty">
                  {product.items[0].qty}
                </div>
                <div className="price">
                  {`$${(product.items[0].price || 0).toFixed(2)}`}
                </div>
                <div className="category">
                  {product.categories?.map((c) => c.name).join(', ')}
                </div>
                <div className="status" style={{ color: product.status === 'ACTIVE' ? '#0B8B00' : '#F40000' }}>
                  {_.upperFirst(_.lowerCase(product.status))}
                </div>
              </LazyLoad>
            ))}
          </div>
        </div>
      ) : <Loader />}
    </div>
  );
}

export default ProductsTable;
